import { styled } from '@mui/system';
import { Pagination } from '@mui/material';
import PageBar from '#component/general/page-bar';

export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2)
  },
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled('div')(() => ({
  height: 1
}));

export const SwitcherContainer = styled('div')(() => ({
  gridArea: 'dateRange',
  textAlign: 'right'
}));

export const FilterButtonContainer = styled(PageBar)(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'auto 160px',
  gridTemplateAreas: '"filter dateRange"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateRows: 'auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'start',
    gridTemplateColumns: 'auto 216px'
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    gridTemplateAreas: '"sortControl dateRange" "filter filter"',
    gridTemplateColumns: 'auto',
    padding: theme.spacing(3, 1, 2, 1)
  }
}));

export const DeviceMobileFilter = styled('div')(() => ({
  padding: '32px 8px 10px 8px'
}));
